import React, { Component } from 'react';
import { connect } from 'react-redux';
import CKEditor from "react-ckeditor-component";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { saveCommentAction} from '../actions/huddleCommentsAction';

import { Collapse} from 'reactstrap';

let config = {
    toolbarGroups: [
        { name: "document", groups: ["mode", "document", "doctools"] },
        {
            name: "editing",
            groups: ["find", "selection", "spellchecker", "editing"]
        },
        { name: "forms", groups: ["forms"] },
        { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
        {
            name: "paragraph",
            groups: ["list", "indent", "blocks", "align", "bidi", "paragraph"]
        },
        "/",
        { name: "links", groups: ["links"] },
    ],
    removeButtons:
        "Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Find,SelectAll,Scayt,Replace,Form,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,CreateDiv,BidiLtr,BidiRtl,Language,Flash,Smiley,SpecialChar,PageBreak,Iframe,Anchor,ShowBlocks,About,CopyFormatting,Undo,Redo,Source",
    fontSize_sizes: "16/16px;24/24px;48/48px;",
    font_names:
        "Arial/Arial, Helvetica, sans-serif;" +
        "Times New Roman/Times New Roman, Times, serif;" +
        "Verdana",
        tabFocus : true,
	allowedContent: true,
	
	startupFocus : 'end'
};
class ReplyHuddleComments extends Component {


	constructor(props) {

		super(props)

		this.state = {
			isOpen: false,
			commentText:'',
			parentPostId:'',
			huddleId:'',
		}

	this.toggle= this.toggle.bind(this);
	this.onChangeComment= this.onChangeComment.bind(this);
	this.onFocus= this.onFocus.bind(this);
	this.postReply= this.postReply.bind(this);
	this.saveReply= this.saveReply.bind(this);

	

	}

	onFocus = (e)=>{

		// e.editor.focus();
		// var selection = e.editor.getSelection();
		// var range = e.selection.getRanges()[0];
		// var pCon = e.range.startContainer.getAscendant({p:2},true); //getAscendant('p',true);
		// var newRange = new e.dom.range(range.document);
		// newRange.moveToPosition(pCon, e.POSITION_BEFORE_START);
		// newRange.select();
	}

	componentDidMount(){


	}

	toggle =(e)=>{

		if(!this.props.userInfo){
			this.props.history.push('/login')
		}
e.preventDefault();
		this.setState({
			isOpen:!this.state.isOpen,
			commentText:'',
			parentPostId:this.props.parent,
			huddleId:this.props.huddleId,
		})
	}

	postReply =(e)=>{
		if(!this.props.userInfo){
			this.props.history.push('/login')
		}
e.preventDefault();


// create a new dov container
let div = document.createElement('div');

// assing your HTML to div's innerHTML
div.innerHTML = this.props.post;

// get all <a> elements from div
let elements = div.getElementsByClassName('rplyDv');

// remove all <div class="rplyDv"> elements
while (elements[0])
   elements[0].parentNode.removeChild(elements[0])

// get div's innerHTML into a new variable
let repl = div.innerHTML;

setTimeout(() => {
	let replyContent = `<div class="rplyDv" style="background-color:#f4f4f4!important;height:100%; padding:1%">
	
	<b>Quoted from: ${this.props.quotedFrom}</b>
	 <a href="#post-${this.props.type=='og'?'og':this.props.parent}">View post</a>
	 <div>${repl}</div></div>
	 <span style="white-space: pre-line">&nbsp;</span>`;


		this.setState({
			isOpen:!this.state.isOpen,
			commentText:replyContent,
			parentPostId:this.props.parent,
			huddleId:this.props.huddleId,
		})
});
	}
	onChangeComment =(e)=>{
		let newContent = e.editor.getData();
        this.setState({
       
                commentText: newContent
            
        })
	}
	saveReply =(e)=>{
		e.preventDefault();

	const {huddleId, parentPostId, commentText} = this.state

let formData = {
	huddleId, 
	parentPostId, 
	comment: commentText
}
	if(commentText){
		this.props.saveComment(formData);

		setTimeout(() => {

			this.setState({
				huddleId, 
				parentPostId:0, 
				commentText: '',
				isOpen:!this.state.isOpen,
			 })
			  
		  },2000);
	}
	}






	render() {

const {isOpen, commentText} = this.state
const {submitLoader} = this.props

		return (

		
		                      	<div >
		                      	
		                      		
										   <a href="#" onClick={this.postReply}>Reply</a>
										   <span className="dot"></span>
		                         
									  <div className="clearfix mb-5"></div>
									

									  <Modal isOpen={isOpen} toggle={this.toggle} size={'lg'} >
									  <ModalBody>
		  <CKEditor

                   
				   config={config}
				   activeClass="p10"
				   content={commentText}
				   events={{

					   "change":this.onChangeComment,
					  	"focus":this.onFocus
					 
					   
				   }}
				 

				  

			   />



			   
									  </ModalBody>
              <ModalFooter>
              {commentText&&<span><a href="#"  className="btn add-comment pull-right"   onClick ={this.saveReply} >{!submitLoader?`Post Reply`:`Posting...`}</a>
									  </span>}
                <Button color="secondary" onClick={this.toggle}>Cancel</Button>
              </ModalFooter>
            </Modal>
									
									
		                      	</div>
		                 
		)
	}
}
const mapStateToProps = state => ({
	loader: state.huddleDetailsReducer.loader,
	userInfo:state.profileReducer.result,
	submitLoader:state.huddleCommentsReducer.submitLoader,
  
  
  })
  const mapDispatchToProps = dispatch => ({
	saveComment: (formData)=>dispatch(saveCommentAction(formData))
  
  })

export default connect(mapStateToProps,mapDispatchToProps) (ReplyHuddleComments)
